import { render, staticRenderFns } from "./TeamMembersSkeleton.vue?vue&type=template&id=00f2a67e&scoped=true"
import script from "./TeamMembersSkeleton.vue?vue&type=script&lang=js"
export * from "./TeamMembersSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TeamMembersSkeleton.vue?vue&type=style&index=0&id=00f2a67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f2a67e",
  null
  
)

export default component.exports